var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_2005)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_936_2005)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_936_2005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3836 14.207H12.0473V10.5451C12.0473 9.67196 12.0298 8.54807 10.8287 8.54807C9.61105 8.54807 9.4252 9.49838 9.4252 10.4811V14.207H7.088V6.67727H9.33227V7.70297H9.36295C9.6768 7.11209 10.4395 6.48703 11.5792 6.48703C13.9462 6.48703 14.3845 8.04574 14.3845 10.0735V14.207H14.3836ZM4.44924 5.64718C4.27088 5.6474 4.09424 5.61242 3.92943 5.54426C3.76462 5.4761 3.61489 5.37607 3.48881 5.24992C3.36274 5.12375 3.2628 4.97395 3.19474 4.8091C3.12667 4.64424 3.09181 4.46758 3.09216 4.28923C3.09233 4.02082 3.17209 3.7585 3.32135 3.53542C3.47062 3.31235 3.68268 3.13854 3.93072 3.03599C4.17876 2.93343 4.45164 2.90674 4.71485 2.95927C4.97807 3.0118 5.21979 3.14121 5.40945 3.33112C5.59912 3.52104 5.72821 3.76293 5.78041 4.02621C5.83262 4.28949 5.80557 4.56234 5.7027 4.81025C5.59982 5.05815 5.42571 5.27 5.20246 5.41894C4.9792 5.56793 4.71677 5.64736 4.44836 5.64718H4.44924ZM5.62046 14.207H3.27713V6.67727H5.62134V14.207H5.62046ZM15.554 0.759766H2.10503C1.4598 0.759766 0.939941 1.26823 0.939941 1.8968V15.4027C0.939941 16.0313 1.46068 16.5398 2.10415 16.5398H15.5505C16.1939 16.5398 16.7199 16.0313 16.7199 15.4027V1.8968C16.7199 1.26823 16.1939 0.759766 15.5505 0.759766H15.5531H15.554Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_2005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.78,
    height: 15.78,
    fill: "white",
    transform: "translate(0.939941 0.759766)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_936_2005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.78,
    height: 15.78,
    fill: "white",
    transform: "translate(0.939941 0.759766)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_936_2005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.78,
    height: 15.78,
    fill: "white",
    transform: "translate(0.939941 0.759766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInSmall);
export default __webpack_public_path__ + "static/media/linkedIn-small.bd3a446055c1dc0b116443f1b5b5728c.svg";
export { ForwardRef as ReactComponent };